import { render, staticRenderFns } from "./ProductionReturnList.vue?vue&type=template&id=47bef973&"
import script from "./ProductionReturnList.vue?vue&type=script&lang=js&"
export * from "./ProductionReturnList.vue?vue&type=script&lang=js&"
import style0 from "./ProductionReturnList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
